import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Outlet } from "react-router-dom";

import { Box, CssBaseline, Paper as MuiPaper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { spacing } from "@mui/system";

import GlobalStyle from "../components/GlobalStyle";
import Navbar from "../components/navbar/Navbar";
import defaultDashboardItems from "../components/sidebar/dashboardItems";
import Sidebar from "../components/sidebar/Sidebar";
import Footer from "../components/Footer";
import Settings from "../components/Settings";
import { useMenuContext } from "../contexts/MenuContext";
import { GetCompanies } from "src/services/generalService";

const drawerWidth = 258;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

const Dashboard = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  //const [dashboardItems, setDashboardItems] = useState(defaultDashboardItems);
  const [companies, setCompanies] = useState([]);
  const [dashboardItems, setDashboardItems] = useState(defaultDashboardItems);
  const [hideSideBar, setHideSideBar] = useState(
    localStorage.getItem("HIDE_SIDE_MENU")
  );
  const { userMenu } = useMenuContext();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    (async () => {
      const { data: companies } = await GetCompanies();
      if (companies && companies.length) {
        let d = [];
        try {
          d = JSON.parse(companies);
          d.forEach((element) => {
            if (element.branches)
              element.branches = JSON.parse(element.branches);
          });
        } catch (error) {}
        setCompanies(d || []);
      }
    })();
  }, []);

  useEffect(() => {
    if (Array.isArray(userMenu) && userMenu.length) {
      setDashboardItems(userMenu);
    }
  }, [userMenu]);

  let sideBar;
  if (hideSideBar) {
    sideBar = (
      <Box sx={{ display: { xs: "block" } }}>
        <Sidebar
          PaperProps={{ style: { width: drawerWidth } }}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          items={dashboardItems}
        />
      </Box>
    );
  } else {
    sideBar = (
      <Drawer>
        <Box sx={{ display: { xs: "block", lg: "none" } }}>
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            items={dashboardItems}
          />
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            items={dashboardItems}
          />
        </Box>
      </Drawer>
    );
  }

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      {sideBar}
      <AppContent>
        <Navbar onDrawerToggle={handleDrawerToggle} companies={companies} />
        <MainContent p={isLgUp ? 12 : 5} style={{ paddingTop: 5 }}>
          {children}
          <Outlet />
        </MainContent>
        <Footer />
      </AppContent>
      <Settings />
    </Root>
  );
};

export default Dashboard;
